import React, { Component, Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import Spinner from 'tcomponents/molecules/SpinnerComponent';
import './variables.css';

import CognitoTenantValidator from '@tekion/tap-components/molecules/CognitoTenantValidator';
import NotificationWrapper from 'tcomponents/organisms/NotificationWrapper';
import TokenManager from '@tekion/tap-components/utils/TokenManager';
import Toaster from '@tekion/tap-cognito-lib/utils/toaster.utils'

import { setDefaultModuleServices } from 'services/http';
import BuildInfoWrapper from '../../../tap-dev-kit/common/components/BuildInfoWrapper';
import { APP_BUILD_TIME } from '../../../config/Meta';
import translate from 'ti18n/translate'; // IIFE

import Routes from './routes';

class App extends Component {
  constructor() {
    super();
    setDefaultModuleServices();
    this.state = { isLoading: true };
  }

  componentDidMount() {
    this.setState({ isLoading: false });
  }

  renderRoutes() {
    const currentTenantCode = TokenManager.getItemFromSession(TokenManager.tenantCodeKey) || TokenManager.getItem(TokenManager.tenantCodeKey);
    return (
      <Fragment>
        <Switch>
          <Route path="*" component={Routes} />
        </Switch>
        <CognitoTenantValidator urlTenantCode={currentTenantCode} routesToCheck={['/app/home', '/app/settings', '/app/tapapplications']}/>
        <NotificationWrapper />
        <BuildInfoWrapper buildTime={APP_BUILD_TIME} />
        {Toaster.renderWrapper()}
      </Fragment>
    );
  }

  renderSpinner = () => (
    <div className="full-height full-width loader">
      <Spinner className="hv-center" id="iotMonitoringSpinner" size="large" />
    </div>
  )

  render() {
    const { isLoading } = this.state;
    return isLoading ? this.renderSpinner() : this.renderRoutes();
  }
}

export default (translate()(App));
